export default "__VITE_ASSET__BGbC2ut$__"